import script from "./classification.vue?vue&type=script&setup=true&lang=js"
export * from "./classification.vue?vue&type=script&setup=true&lang=js"

import "./classification.vue?vue&type=style&index=0&id=3581e868&lang=scss"

const __exports__ = script;

export default __exports__